import { Zap } from "lucide-react";
import { CommandAction } from "../../lib/commandCore";

interface Props {
  brief: string;
  nextAction: CommandAction;
  nextActionLabel: string;
}

const actionTone: Record<CommandAction, string> = {
  A: "border-sky-200 bg-sky-50 text-sky-800 dark:border-sky-400/35 dark:bg-sky-400/10 dark:text-sky-100",
  B: "border-indigo-200 bg-indigo-50 text-indigo-800 dark:border-indigo-400/35 dark:bg-indigo-400/10 dark:text-indigo-100",
  C: "border-emerald-200 bg-emerald-50 text-emerald-800 dark:border-emerald-400/35 dark:bg-emerald-400/10 dark:text-emerald-100",
  D: "border-border bg-hover text-muted dark:border-zinc-500/50 dark:bg-zinc-500/15 dark:text-zinc-200",
};

export function TodayBrief({ brief, nextAction, nextActionLabel }: Props) {
  return (
    <section className="command-card p-4 shadow-md dark:shadow-[0_18px_60px_-36px_rgba(99,102,241,0.75)] md:p-5">
      <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="flex min-w-0 items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-amber-400 text-stone-950">
            <Zap className="h-5 w-5" />
          </div>
          <div className="min-w-0">
            <p className="command-muted text-sm font-semibold">今日の要点</p>
            <p className="mt-1 break-words text-lg font-semibold text-text dark:text-white md:text-2xl">{brief}</p>
          </div>
        </div>
        <div className={`shrink-0 rounded-md border px-4 py-3 ${actionTone[nextAction]}`}>
          <div className="font-mono text-2xl font-bold">{nextAction}</div>
          <div className="mt-0.5 text-sm font-semibold">{nextActionLabel}</div>
        </div>
      </div>
    </section>
  );
}
